/*
 *  Home Stockist
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2020/02/11
 */


import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-featured-blog]';
export const CAROUSEL_SELECTOR = '[data-featured-blog-carousel]';
export const CAROUSEL_BUTTON_PREV = '[data-arrow-prev]';
export const CAROUSEL_BUTTON_NEXT = '[data-arrow-next]';
export const TAG_CAROUSEL_SELECTOR = '[data-tags]';

export class FeaturedBlog extends CarouselSection {
  constructor(container) {
    super(container);

    this.prevButton = container.find(CAROUSEL_BUTTON_PREV);
    this.nextButton = container.find(CAROUSEL_BUTTON_NEXT);

    this.tagSlideOptions = {
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: false,
      arrows: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 3, slidesToScroll: 3}
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 4, slidesToScroll: 4}
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 6, slidesToScroll: 6}
        }
      ]
    }

    
    // carousel
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.tagCarousel = container.find(TAG_CAROUSEL_SELECTOR);

    this.slick = this.initCarousel(this.carouselContainer);
    this.reSlick(ResponsiveSizes.small, this.carouselContainer);
    this.slickTags = this.tagSlide(this.tagCarousel);

  }

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 1,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      speed: this.carouselContainer.data('slide-speed') || 500,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      variableWidth: false,
      prevArrow: this.prevButton,
      nextArrow: this.nextButton,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-2,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: 499,
          settings: { variableWidth: true }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2, slidesToScroll: 2,variableWidth: false }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 3, slidesToScroll: 3,arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 3, slidesToScroll: 3,arrows: true }
        }
      ]
    }
  }

  tagSlide(e){
    let tagSlide = e.slick({
      ...this.tagSlideOptions
    });

    return tagSlide;
  }

}

register(CONTAINER_SELECTOR, FeaturedBlog);